/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="container">
        <div className="row justify-content-center mt-4">
          <div className="col-lg-8 para-last">
            <div className="d-flex justify-content-between">
              <p>Trem of Use</p>
              <p>Privacy</p>
              <p onClick={() => navigate('/about')}>
                About Us
                </p>
              <p>Contact Us</p>
              <p onClick={() => navigate('/signup')}>Register</p>
              <p>FAQ</p>
            </div>
          </div>
        </div>
        <div className="row footer pb-4">
          <p>
            Copyright © 2024 Pet Avenger. All rights reserved. All trademarks,
            service marks, and tradenames (collectively, the "Marks") are
            trademarks or registered trademarks of Pet Avenger.
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;
